import styled from '@emotion/styled';
import { sdsColor, sdsRadius } from '@staging-design-system/tokens';
import { rem } from '@utils';

const Root = styled.button<{
  $selected?: boolean;
  $showLabel?: boolean;
  $expandable?: boolean;
}>(
  ({ $selected, $expandable, $showLabel = true }) => `
  align-items: center;
  background: ${$selected && !$expandable ? sdsColor.background.brandSecondary : sdsColor.background.defaultSecondary};
  border: none;
  border-radius: ${sdsRadius.xSmall};
  color: ${$selected && !$expandable ? sdsColor.text.brandSecondary : sdsColor.text.defaultDefault};
  cursor: pointer;
  display: flex;
  gap: ${rem(8)};
  font-family: inherit;
  font-size: ${rem(14)};
  font-weight: 400;
  justify-content: ${$showLabel ? 'flex-start' : 'center'};
  line-height: ${rem(20)};
  min-height: ${$showLabel ? rem(40) : 'auto'};
  padding: ${rem(8)};
  text-align: left;
  text-decoration: none;
  transition:
    background 200ms ease,
    color 200ms ease;
  width: ${$showLabel ? '100%' : 'auto'};

  &:hover, &:active {
    &:not(:disabled):not([disabled]) {
      background: ${$selected && !$expandable ? sdsColor.background.brandSecondary : sdsColor.background.defaultDefaultHover};
      color: ${$selected && !$expandable ? sdsColor.text.brandSecondary : sdsColor.text.defaultDefault};
    }
  }

  &:focus-visible {
    outline: ${rem(2)} solid ${sdsColor.border.brandSecondary};
    outline-offset: -${rem(2)};
  }

  &:disabled, &[disabled] {
    background: transparent;
    color: ${sdsColor.text.disabledDefault};
    cursor: not-allowed;
  }
`
);

const LeadingIcon = styled.span`
  align-items: center;
  color: inherit;
  display: inline-flex;
  flex-shrink: 0;
  height: ${rem(16)};
  justify-content: center;
  pointer-events: none;
  width: ${rem(16)};

  svg {
    display: block;
    height: ${rem(16)};
    pointer-events: none;
    width: ${rem(16)};
  }
`;

const TrailingIcon = styled.span<{ $isExpanded?: boolean }>(
  ({ $isExpanded }) => `
  align-items: center;
  color: inherit;
  display: inline-flex;
  flex-shrink: 0;
  height: ${rem(16)};
  justify-content: center;
  pointer-events: none;
  width: ${rem(16)};

  svg {
    display: block;
    height: ${rem(8)};
    pointer-events: none;
    transition: transform 200ms ease;
    transform: rotate(${$isExpanded ? '180deg' : '0deg'});
    width: ${rem(8)};
  }
`
);

const Label = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  pointer-events: none;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default {
  Label,
  LeadingIcon,
  TrailingIcon,
  Root
};
